(function ($) {
    $(document).ready(function () {
        $('#stuck-container').TMStickUp();
    });
})(jQuery);
